import { Star } from 'lucide-react';

interface RatingStarsProps {
  rating: number;
  maxRating?: number;
}

export function RatingStars({ rating, maxRating = 10 }: RatingStarsProps) {
  const displayMax = Math.min(maxRating, 10);

  return (
    <div className="flex gap-0.5 items-center">
      {Array.from({ length: displayMax }, (_, idx) => idx + 1).map((starNum) => (
        <Star
          key={`star-${starNum}`}
          className={`h-4 w-4 ${
            starNum <= rating ? 'fill-yellow-400 text-yellow-400' : 'text-muted-foreground'
          }`}
        />
      ))}
      <span className="ml-2 text-sm text-muted-foreground">({rating}/{maxRating})</span>
    </div>
  );
}
